import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

@Component({
  selector: 'app-infrastructure',
  templateUrl: './infrastructure.component.html',
  styleUrl: './infrastructure.component.scss',
})
export class InfrastructureInfoComponent implements OnInit{
  @Input() infraestructures = null;
  listMap = false;
  temporalInfraestructure = null;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow;
  centerMap: google.maps.LatLngLiteral;
  zoomMap = 12;
  positionMarker: google.maps.LatLngLiteral;
  options = {
    draggable: true
  };
   //MAP INFRAESTRUCTURA
  center: google.maps.LatLngLiteral;
  zoom = 12;

  ngOnInit(): void {
    //centrar mapa
    navigator.geolocation.getCurrentPosition((position) => {
      this.centerMap = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });
  }

  closeListMap() {
    if ((this.listMap = true)) {
      document.querySelector('.container-list-map').classList.remove('animate__animated', 'animate__slideInRight');
      document.querySelector('.container-list-map').classList.add('animate__animated', 'animate__slideOutRight');
      setTimeout(() => {
        this.listMap = false;
      }, 1000);
    }
  }

  openLocation(item) {
    this.centerMap = {
      lat: item.lat,
      lng: item.lng,
    };
    this.center = {
      lat: item.lat,
      lng: item.lng,
    };
    this.closeListMap();
  }

  openInfo(marker: MapMarker, content) {
    this.temporalInfraestructure = content;
    this.infoWindow.open(marker)
  }
}
